document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".slider_track");
  const slides = document.querySelectorAll(".slide");
  const prev = document.querySelector(".slider_arrow.prev");
  const next = document.querySelector(".slider_arrow.next");

  let current = 0;

  function updateSlider() {
    track.style.transform = `translateX(-${current * 100}%)`;
  }

  prev.addEventListener("click", () => {
    current = (current > 0) ? current - 1 : slides.length - 1;
    updateSlider();
  });

  next.addEventListener("click", () => {
    current = (current + 1) % slides.length;
    updateSlider();
  });

  // 🔥 Swipe en móvil
  let startX = 0;
  let endX = 0;

  track.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  }, { passive: true });

  track.addEventListener("touchend", (e) => {
    endX = e.changedTouches[0].clientX;
    const delta = endX - startX;

    if (Math.abs(delta) > 50) {
      if (delta < 0) {
        // Swipe izquierda
        current = (current + 1) % slides.length;
      } else {
        // Swipe derecha
        current = (current > 0) ? current - 1 : slides.length - 1;
      }
      updateSlider();
    }
  }, { passive: true });
});
